export interface ChannelInfo {
  tag: string;
  description: string;
  channel_type: string;
  turbine: string;
}

export interface ChannelLookup {
  config_name: string;
  channel_name: string;
}

function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

/**
 * Batch lookup of channel info for a list of (config, channel) pairs.
 * Returns one ChannelInfo per input in the same order. Unknown channels are
 * returned with the input channel name in both `tag` and `description`.
 *
 * Pass `useTrendChannels = true` when the channels belong to a trend graph
 * (e.g. trend XY prepop) so the lookup reads from the trend channel store.
 */
export async function getChannelInfo(
  channels: ChannelLookup[],
  useTrendChannels = false,
): Promise<ChannelInfo[]> {
  if (channels.length === 0) return [];
  if (isTauri()) {
    const { invoke } = await import("@tauri-apps/api/core");
    return await invoke<ChannelInfo[]>("get_channel_info", { channels, useTrendChannels });
  }
  const response = await fetch("/api/get_channel_info", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ channels, use_trend_channels: useTrendChannels }),
  });
  if (!response.ok) throw new Error(`get_channel_info failed: ${response.status}`);
  return await response.json();
}
